import { gql } from '@apollo/client';

export const VALIDATE_PROMOCODE = gql`
  query validatePromocode($promocode: ValidatePromoCodeInput!) {
    validatePromoCode(input: $promocode) {
      id
      author {
        login
      }
      client {
        login
      }
      code
      value
      amount
      entity
      entity_id
      created_at
    }
  }
`;
